import {
  Button,
  Box,
  Card,
  Typography,
  Stack,
  Grid,
  IconButton,
} from "@mui/material";
import moment from "moment";
import { Clear } from "@mui/icons-material";
import { Man, Woman, Edit } from "iconsax-react";
import helpTooltip from "../../../../static/img/icons/help-tooltip.svg";
import Swal from "sweetalert2";
import "./index.css";
import React, { useRef, useEffect } from "react";


const CardList = ({
  getFilterBySegmentType = () => { },
  roomAllocationData,
  segmentType,
  handleOnDrop = () => { },
  handleDragOver = () => { },
  handleDelete = () => { },
  handleOnChangeRemarks = () => { },
  draggedRoomType,
}) => {
  return (
    <>
      <Grid container>
        {getFilterBySegmentType(roomAllocationData, segmentType).map(
          (room, index) => (
            <Grid item md={6}>
              <Card
                key={index}
                onDrop={(e) => handleOnDrop(e, room)}
                onDragOver={handleDragOver}
                sx={{
                  backgroundColor:
                    draggedRoomType?.RoomType__c === room?.RoomType__c
                      ? "#C0C0C0"
                      : "#FFFFFF",
                  border: "1px solid #D0D5DD",
                  borderRadius: "8px",
                  width: "auto",
                  height: "300px",
                  marginTop: "20px",
                  marginLeft: "10px",
                }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginTop: "10px",
                    marginLeft: "12px",
                  }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      background: "#F9FAFB",
                      borderRadius: "8px",
                      width: "147px",
                      height: "40px",
                    }}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "16px",
                        color: "#344054",
                      }}>
                      {room.Name}
                    </Typography>
                  </Box>
                  <Box sx={{ marginLeft: "25px" }}>
                    <Stack direction="row">
                      <Typography
                        sx={{
                          fontWeight: 600,
                          fontSize: "16px",
                        }}>
                        {room.RoomType__c}
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          background: "#F2F4F7",
                          borderRadius: "16px",
                          width: "53px",
                          height: "22px",
                          marginLeft: "5px",
                        }}>
                        <Typography>{segmentType}</Typography>
                      </Box>
                    </Stack>
                    <Typography
                      sx={{
                        color: "#667085",
                        fontSize: "12px",
                        fontWeight: 300,
                      }}>
                      {`(${moment(room.Start_Date__c).format(
                        "DD/MMM/YYYY"
                      )} - ${moment(room.End_Date__c).format("DD/MMM/YYYY")})`}
                    </Typography>
                  </Box>
                  <div
                    style={{
                      marginLeft: "20px",
                      display: "flex",
                      flexDirection: "row",
                    }}>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 300,
                      }}>
                      {room.Sharing_Type__c}
                    </Typography>

                    <img style={{ height: "18px" }} src={helpTooltip} />
                  </div>
                </div>
                <hr />
                <div style={{ marginLeft: "12px" }}>
                  <Stack direction="row" gap={2}>
                    <>
                      <Grid container>
                        {room?.segments?.map((segment, index) => (
                          <Grid item md={6} sm={12}>
                            <Box
                              key={index}
                              sx={{
                                background:
                                  segment.Guest_ID__r.Guest_FullName__r
                                    ?.Gender__c === "Female"
                                    ? "#ECEDF8"
                                    : "#EFFCF9",
                                border:
                                  segment.Guest_ID__r.Guest_FullName__r
                                    ?.Gender__c === "Female"
                                    ? "1px solid #2F37B5"
                                    : "1px solid #8CE2E3",
                                borderRadius: "99px",
                              }}>
                              <Stack
                                direction="row"
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}>
                                {segment.Guest_ID__r.Guest_FullName__r
                                  ?.Gender__c === "Female" ? (
                                  <Woman
                                    color="#134264"
                                    style={{
                                      padding: "4px",
                                      background: "#FFFFFF",
                                      borderRadius: "1332px",
                                    }}
                                  />
                                ) : (
                                  <Man
                                    color="#134264"
                                    style={{
                                      padding: "4px",
                                      background: "#FFFFFF",
                                      borderRadius: "1332px",
                                    }}
                                  />
                                )}

                                <Typography
                                  sx={{
                                    color: "#00023F",
                                    fontWeight: 400,
                                    fontSize: "16px",
                                  }}>
                                  {segment.Guest_ID__r?.Guest_FullName__r?.Name}
                                </Typography>
                                <IconButton
                                  onClick={() =>
                                    handleDelete(segment.Id, room.Id)
                                  }>
                                  <Clear
                                    sx={{
                                      marginLeft: "5px",
                                      marginTop: "5px",
                                    }}
                                  />
                                </IconButton>
                              </Stack>
                            </Box>
                          </Grid>
                        ))}
                      </Grid>
                    </>
                  </Stack>
                </div>
                <hr />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    marginBottom: "15px",
                    padding: "8px 16px",
                  }}>
                  {room.segments && room.segments.length > 0 && (
                    <>
                      {room.Remarks__c ? (
                        <>
                          <Button
                            sx={{
                              width: "auto",
                              height: "36px",
                              background: "#FFFFFF",
                              border: "1px solid #D0D5DD",
                              boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                              borderRadius: "8px",
                            }}
                            onClick={() => {
                              Swal.fire({
                                width: 640,
                                height: 220,
                                padding: "3em",
                                title: "Input Remakrs",
                                input: "text",

                                inputValue: room.Remarks__c,
                                inputPlaceholder: "Remarks",
                                inputAttributes: {
                                  autocapitalize: "off",
                                },
                                showCancelButton: true,
                                confirmButtonText: "Save",
                                showLoaderOnConfirm: true,
                                reverseButtons: true,
                                preConfirm: (value) => {
                                  handleOnChangeRemarks(value, index);
                                },
                                customClass: {
                                  confirmButton: "btn-confirm",
                                  cancelButton: "btn-cancel",
                                },
                              });
                            }}>
                            <Edit color="#344054" />
                            <Typography
                              sx={{
                                marginTop: "3px",
                                paddingLeft: "10px",
                                color: "#00023F",
                                fontSize: "14px",
                              }}>
                              <b>Remarks:</b> {room.Remarks__c}
                            </Typography>
                          </Button>
                        </>
                      ) : (
                        <Button
                          onClick={() => {
                            Swal.fire({
                              width: 640,
                              height: 220,
                              padding: "3em",
                              title: "Input Remakrs",
                              input: "text",

                              inputValue: room.Remarks__c,
                              inputPlaceholder: "Remarks",
                              inputAttributes: {
                                autocapitalize: "off",
                              },
                              showCancelButton: true,
                              confirmButtonText: "Save",
                              showLoaderOnConfirm: true,
                              reverseButtons: true,
                              preConfirm: (value) => {
                                handleOnChangeRemarks(value, index);
                              },
                              customClass: {
                                confirmButton: "btn-confirm",
                                cancelButton: "btn-cancel",
                              },
                            });
                          }}
                          sx={{
                            width: "auto",
                            height: "36px",
                            background: "#FFFFFF",
                            border: "1px solid #D0D5DD",
                            boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                            borderRadius: "8px",
                          }}>
                          <Stack
                            direction="row"
                            sx={{
                              marginTop: "10px",
                              padding: "6px 14px",
                            }}>
                            <Edit color="#344054" />

                            <p
                              style={{
                                fontSize: "14px",
                                color: "#344054",
                                paddingLeft: "5px",
                              }}>
                              Add Remarks
                            </p>
                          </Stack>
                        </Button>
                      )}
                    </>
                  )}
                </Box>
              </Card>
            </Grid>
          )
        )}
      </Grid>
    </>
  );
};

export default CardList;
